// extracted by mini-css-extract-plugin
module.exports = {"itemCircle":"styles_itemCircle__3Vpox","itemCount":"styles_itemCount__1EKbj","lable":"styles_lable__2XvBz"};